import { Icon, type IconName } from "../components/ui/Icon.js";

interface PlaceholderPageProps {
  title: string;
  subtitle?: string;
  icon?: IconName;
  phase: number;
}

export function PlaceholderPage({ title, subtitle, icon = "sparkle", phase }: PlaceholderPageProps) {
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 32,
      }}
    >
      <div className="se-card" style={{ maxWidth: 520, padding: 28, textAlign: "center" }}>
        <div
          style={{
            width: 48,
            height: 48,
            margin: "0 auto 14px",
            borderRadius: 12,
            background: "var(--surface-2)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "var(--ai)",
          }}
        >
          <Icon name={icon} size={22} />
        </div>
        <div style={{ fontSize: 16, fontWeight: 600, marginBottom: 6 }}>{title}</div>
        {subtitle ? (
          <div className="muted" style={{ fontSize: 12, marginBottom: 14 }}>
            {subtitle}
          </div>
        ) : null}
        <span className="se-pill se-pill-ai">Phase {phase}</span>
      </div>
    </div>
  );
}
